import React, { Component, useState, useEffect  } from "react";
import { useNavigate, useLocation } from 'react-router-dom'
import queryString from 'query-string';
/*
import useWebInstallPrompt from '../hooks/useWebInstallPrompt';
*/







function Login (props) {
	//&id=14&tv=123916995
let customspremurl='https://customsprem.gov.tc/';
let resturl='https://customsprem.gov.tc/';

const [dowait, setDowait] = useState({on:false});
	
const queryStringParams = queryString.parse(window.location.search);
if (queryStringParams.drv!=undefined){
	resturl='http://127.0.0.1:3001/';
	customspremurl='http://127.0.0.1:3001/';
	console.log('resturl: '+resturl);
	//console.log('queryStringParams: '+resturlJSON.stringify(queryStringParams));
	}//end if
	


const [cred, setCred] = useState({
adusername: ""
, pwd: ""
, otp: ""
, AW_USERNAME: ""
, AW_USERID: ""
, IP: ""
, otpsent: false
, cbtrust: ""
, authpassed: false
, devicetrusted: null
, devicename:""
});	
//, needpwd: false
useEffect(() => {
	document.title =   "Customs Apps";	
	getipaddress();
	document.getElementsByTagName('body')[0].classList.add("loginbody");

/*
	setCred((prev)=>{
		return {...prev, adusername:"adj", pwd:"adj123"}
	});
*/

	if (document.getElementsByName('adusername')[0])
		document.getElementsByName('adusername')[0].focus();
	
	
	//const event = new Event('beforeinstallprompt')
//window.dispatchEvent(event)
},[]);



useEffect(() => {
	
	//if the device is not trusted, verify otp via email inbox
	sessionStorage.setItem("AW_USERNAME", "");
	
	console.log("will check cred.authpassed: "+cred.authpassed);
	
	if (cred.authpassed==true){
		//		getotp();		
		if (cred.devicetrusted==null)
			checkdevicetrust();
		else if (cred.devicetrusted==1){
			insertloginlog(cred.adusername);
			}//end else
		else{
			disableusername();
			getotp();
			}//end 
			
		}
		

},[cred.authpassed, cred.devicetrusted]);

useEffect(() => {

if (queryStringParams.tv!=undefined){
	checkttlval(queryStringParams.id, queryStringParams.tv)
	}//end if
	
},[cred.IP]);


useEffect(() => {

if (cred.devicename!="")
	trustthisdevice();
	
},[cred.devicename]);



useEffect(() => {
			
	if (cred.otpsent==true){
		if (document.getElementsByName('adusername')[0]){
			document.getElementsByName('adusername')[0].readOnly=true;
			if (!document.getElementsByName('adusername')[0].classList.contains("gnsbro"))
				document.getElementsByName('adusername')[0].classList.add("gnsbro");
			}//end if
			
		if (document.getElementsByName('pwd')[0]){
			document.getElementsByName('pwd')[0].readOnly=true;
			if (!document.getElementsByName('pwd')[0].classList.contains("gnsbro"))
				document.getElementsByName('pwd')[0].classList.add("gnsbro");
			
			}//end if

		if (document.getElementsByName("otp")[0])
			document.getElementsByName("otp")[0].focus();	
		}//end if
	else{
		if (document.getElementsByName('adusername')[0]){
			document.getElementsByName('adusername')[0].readOnly=false;
			if (document.getElementsByName('adusername')[0].classList.contains("gnsbro"))
				document.getElementsByName('adusername')[0].classList.remove("gnsbro");
			}//end if

		if (document.getElementsByName('pwd')[0]){
			document.getElementsByName('pwd')[0].readOnly=false;
			if (document.getElementsByName('pwd')[0].classList.contains("gnsbro"))
				document.getElementsByName('pwd')[0].classList.remove("gnsbro");
			}//end if


		}//end else
	
},[cred.otpsent]);



const navigate = useNavigate();	

const setLoginCred = () =>{
//const adusername=document.getElementsByName('adusername')[0].value;

};

function disableusername(){
			document.getElementsByName("adusername")[0].readOnly=true;
			document.getElementsByName("adusername")[0].classList.add("gnsbro");
			document.getElementsByName("pwd")[0].readOnly=true;
			document.getElementsByName("pwd")[0].classList.add("gnsbro");

}//end func

async function checkttlval(id, tv){

const params={
	id:id
	,ttlval:tv
	};

		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( params )
	  };
setDowait({on:true});

	await  fetch(customspremurl+'rarlogin/ttlval',requestOptions)
		  .then(res => res.json())
		  .then(res => aftercheckttlval(res))
		  .catch(err => console.log(err));

}//end func

function clickLogin(e){
	
	/*
	if user already authenticated then check if the otp matches
	*/
	
	if (cred.authpassed==false)
		loginad();
	else
		getotp();
	
}//end func

async function loginad(){
var md5 = require('md5');

const adusername=(""+cred.adusername).trim();
const pwd=(""+cred.pwd).trim();

if (adusername=="" || pwd==""){
	showsnackbar("please enter username and password");
	return;
	}//end if

const params={
	username:adusername
	,password:md5(pwd)
	};

console.log("params: "+JSON.stringify(params));

		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( params )
	  };
setDowait({on:true});

	  await fetch(customspremurl+'rarauthadng/auth',requestOptions)
		  .then(res => res.json())
		  .then(res => afterloginad(res))
		  .catch(err => console.log(err));
		  
}//end func

function afterloginad(res){
	/*
	changes 9th Nov 2024
	(i)  logging in with AD_USERNAME .insertloginlog changed to accept AD_USERNAME only not AW_USERNAME
	(ii)  when user click login we can request OTP match before call authad, unless the device is trusted by user
	*/
	console.log("afterloginad res: "+JSON.stringify(res));
	setDowait({on:false});
	let authOk=false;
	if (res.auth){
		authOk=(res.auth=="true" || res.auth==true)?true:false;
		}//end if
	
	if (authOk==true){
		//checklocalstorage();
		}
	else
		showsnackbar("login failed!");
	
	setCred((prev)=>{
		return {...prev, authpassed:authOk}
	});		
	
	//insertloginlog();
	//console.log("afterloginad: "+JSON.stringify(res));
}//end func

function aftercheckttlval(res){
console.log("aftercheckttlval AD_USERNAME: "+res[0].AD_USERNAME);
setDowait({on:false});
if (res.length==undefined)
	return;

if (res[0].TTL_RES=="1"){
	//console.log("aftercheckttlval: "+res[0].AD_USERNAME);
	insertloginlog(res[0].AD_USERNAME);
	}
	
}//end func

async function checkdevicetrust(){

let trust=localStorage.getItem(cred.adusername+"@customsapps.gov.tc");
console.log("checkdevicetrust trust: "+trust);
if (!trust)
	trust="";
else if (trust==null)
	trust="";

if (trust==""){
	setCred((prev)=>{
		return {...prev, devicetrusted:0}
	})	;
	return;
	}//end if

/*
this check to verify if the trust data on the device
matches the database
*/
const params={
	cred:cred
	, trust:trust
	};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };	
  
  setDowait({show:true});
	
  await fetch(resturl+'rarlogin/trustdevice',requestOptions)
      .then(res => res.json())
      .then(res => 	{aftercheckdevicetrust(res);  } )
      .catch(err => console.log(err));

	//console.log('aftergetwpapp: '+res[0].OCCUPATION);
}//end func

function aftercheckdevicetrust(res){
let MATCH_COUNT=0;
if (res.length)
	if (res.length==1){
		MATCH_COUNT=res[0].MATCH_COUNT;
		sessionStorage.setItem("TRUSTED_DEVICE", res[0].DEVICE_NAME);
		}//end if
		

setCred((prev)=>{
	return {...prev, devicetrusted:MATCH_COUNT}
})	;
	
}//end func



function getipaddress(){
		
fetch('https://api.ipify.org?format=json',{ method: 'GET' })
  .then(res => res.json())
  .then(res => aftergetipaddress(res) )
  .catch(err => getipaddresserr(err) );	
  
}//end func

function getipaddresserr(err){
setCred((prev)=>{
	return {...prev, IP:"0.0.0.0" }
	});
console.log(err);
}//end func

function aftergetipaddress(res){
	
setCred((prev)=>{	
return {...prev, IP:res.ip} 
	});
	
}//end func

async function insertloginlog(AD_USERNAME){
/*
reason why call to insertloginlog does not rely on cred.adusername
the user has the option to login via customsapps.tcig.tc which passes URL args to identify the user via checkttlval
when this route is used, cred.adusername is not set
aftercheckttlval makes the call to insertloginlog using the result from a db query
*/
console.log('insertloginlog AD_USERNAME: '+AD_USERNAME);

const jsonObj={
	AD_USERNAME:AD_USERNAME
	,IP:cred.IP
	};

		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( jsonObj )
	  };
setDowait({on:true});

	  await fetch(resturl+'rarlogin/insertloginlog',requestOptions)
		  .then(res => res.json())
		  .then(res => afterinsertloginlog(res))
		  .catch(err => console.log(err));

}//end func

function afterinsertloginlog(res){

if (res[0].AW_USERNAME=='')
	showsnackbar("login failed");
else{

/*
LOGINTIME,CUSTOMERACCOUNT,DEC_COD,IRD_LOGIN_ID,AW_USERID,AW_USERNAME,GOV_adusername
,ACC_COD,adusername_SELECTIVITY,DEC_BRK,IRD_EMPLOYEE_NO,TAX_CENTRE_NO,IRD_EMP_NAME
,TAX_CENTRE_DESC,DEPT_DESC,MINISTRY_DESC,FILE_PATH,VOUCHER_LINK,VOUCHER_FOLDER
,USER_CUO_COD,MILLISECONDS,LAST_SAD_DATES
*/
	
for(var attributename in res[0]){
	let valu=res[0][attributename]==null?"":""+res[0][attributename];
	console.log("attributename, valu: "+attributename+","+valu);
	if (valu.toLowerCase()=="null")
		valu="";
	sessionStorage.setItem(attributename, valu);
	}//end for	
	
	
	console.log('sessionStorage AW_USERNAME: '+sessionStorage.getItem("AW_USERNAME"));
	console.log('sessionStorage LAST_SAD_DATES: '+sessionStorage.getItem("LAST_SAD_DATES"));
	getjobqoptions();// calls getSessionvars() when done
	
	
	}//end else

	
}//end func

function getjobqoptions(){
//needed at login so the sad page has CPC beneficiaries, also for Jobq Declarant options	
const requestOptions = {
  method: 'GET'
};//jobqoptions
setDowait({on:true});
fetch(resturl+'rarlogin/jobqoptions',requestOptions)
  .then(res => res.json())
  .then(res => aftergetjobqoptions(res) )
  .catch(err => console.log(err));	
}//end func

function aftergetjobqoptions(res){
setDowait({on:false});
sessionStorage.setItem("jobqoptions", JSON.stringify(res));
console.log("sessionStorage jobqoptions.length: "+sessionStorage.getItem("jobqoptions").length);
getSessionvars();
}//end func

function getSessionvars(){
const requestOptions = {
  method: 'GET'
};
setDowait({on:true});
fetch(resturl+'rarlogin/getsessionvars',requestOptions)
  .then(res => res.json())
  .then(res => aftergetSessionvars(res) )
  .catch(err => console.log(err));	
}//end func

function aftergetSessionvars(res){
	
console.log('aftergetSessionvars: '+JSON.stringify(res));	

setDowait({on:false});
//console.log('aftergetSessionvars: '+JSON.stringify(res));
//console.log('aftergetSessionvars res.length: '+res.length);
res.map((col, index) => {
	sessionStorage.setItem(col['SESSIONVAR'], col['VALU']);
});		


if (cred.cbtrust==1)
	getDeviceName();
else
	navigate('/dashboard');

}//end func


function getDeviceName(){
	
	document.getElementsByName("cbtrust")[0].checked=false; 
	
	var deviceName='';
    const UserAgent = navigator.userAgent;
    const device = {
        iPad: /iPad/.test(UserAgent),
        iPhone: /iPhone/.test(UserAgent),
        Android: /Android/.test(UserAgent),
        Windows: /Windows/.test(UserAgent)
    }

    for(var dev in device){
        if(device[dev])
        	deviceName = dev;
    }
    
setCred((prev)=>{
	return {...prev
	,"devicename":deviceName
	}
});

}//end func

function getotp(){
//document.getElementsByName('pwd')[0].value
//document.getElementsByName('adusername')[0].value
// we will have to find and send the email matching adusername
//email:cred.adusername+"@gov.tc"
//must modify SP_ONETIMEPASSWORD to check email for @.  If absent assume its AD_USERNAME
const adusername=(""+cred.adusername).trim();
if (adusername==""){
	console.log("abort getotp() for adusername==''");
	return;
	}
	
const params={
	email:cred.adusername
	,ip:''
	,otp: cred.otp
	};

//console.log('getotp params'+JSON.stringify(params));

		const requestOptions = {
		  method: 'POST'
		  ,headers: { 'Content-Type': 'application/json' }
		  ,body: JSON.stringify( params )
	  };

	setDowait({on:true});
	  fetch(resturl+'rarlogin/getotp',requestOptions)
		  .then(res => res.json())
		  .then(res => aftergetotp(res))
		  .catch(err => console.log(err));

}//end func



function aftergetotp(res){
setDowait({on:false});
console.log('res[0].MATCH_OTP: '+res[0].MATCH_OTP);
if (cred.otpsent==true){
	if (res[0].MATCH_OTP==1){
		insertloginlog(res[0].AD_USERNAME);//
/*
setCred((prev)=>{
			return {...prev, authpassed:true}
		});
*/		
		}//end if
	else
		showsnackbar('login failed');
	}//end if
else{
	setCred((prev)=>{ return {...prev,otpsent:true} }) ;
	showsnackbar('please check your email inbox for one-time-password');
	document.getElementsByName("pwd")[0].focus();
	}//end if

	
}//end func

function handleChange(e){
	
const {name,value}= e.target;
//console.log("handleChange: "+name+", "+value);
setCred((prev)=>{
	return {...prev, [name]:value}
});
	
}//end func








function afteraduserdevice(res){
	console.log("afteraduserdevice: "+JSON.stringify(res));
	let trustdevice=false;
	if (res.length)
		if (res.length>0)
			if (res[0].MATCH_COUNT>0)
				trustdevice=true;
			
	if (trustdevice==true)
		insertloginlog(cred.adusername);
	else
		getotp();
}//end func


function devicenameChangeOld(e){
	setCred((prev)=>{
		return {...prev, [e.target.name]:e.target.value}
	});
}//end func

async function trustthisdevice(){
	const devicename=(""+cred.devicename).trim();

/*
	if (devicename.length<5){
		showsnackbar("the device name must me 5 characters or more");
		return;
		}//end if
*/	

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {cred:cred, trust:"", USERNAME:sessionStorage.getItem("AW_USERNAME")} )
  };	
  
  setDowait({show:true});
	
  await fetch(resturl+'rarlogin/trustdevice',requestOptions)
      .then(res => res.json())
      .then(res => 	{aftertrustthisdevice(res);  } )
      .catch(err => console.log(err));

	//console.log('aftergetwpapp: '+res[0].OCCUPATION);
}//end func

function aftertrustthisdevice(res){
	
console.log('aftertrustthisdevice: '+JSON.stringify(res));	
	
let TRUST="";
if (res.length)
	if (res.length==1)
		TRUST=res[0].TRUST;

if (TRUST=="")	
	showsnackbar("that failed!  please try again or contact admin")
else{
	localStorage.setItem(cred.adusername+"@customsapps.gov.tc",TRUST);
	showsnackbar("the device is now trusted");
	//toggleModalsm();
	//window.alert(cred.adusername+" ; "+localStorage.getItem(cred.adusername+"@customsapps.gov.tc") );
	navigate("/dashboard");
	}//end else
		
		
}//end func

function promptdevicenameOld(){
	
document.getElementsByName("cbtrust")[0].checked=false; 
toggleModalsm();
document.getElementsByName("devicename")[0].value='';
document.getElementsByName("devicename")[0].focus();
	
}//end func


function toggleModalsm() {
const modalsm = document.querySelector(".modalsm");

	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func

function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
	
console.log('event.target === modalsm: '+(event.target === modalsm));
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }
}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 5000);
}//end func





const handleFocus = (e) => {
	e.target.select();
}


const location = useLocation();
console.log('location.pathname: '+location.pathname);
console.log('window.location: '+window.location);



      window.addEventListener("keypress", function (event) {
         // detect event key
         if (event.keyCode == 13) {
			 /*document.getElementById("btnlogin").click();*/
			 
         }
      });

/*
const deviceName = navigator?.userAgentData?.platform || navigator?.platform;
ReactGA.initialize(`${process.env.REACT_APP_GA_ID}`, {
	
	//getDeviceName()
  gaOptions: {
    device_name: deviceName,
    page_location: window.location.href,
  },
});

*/

     return (
		<>

	<table border="0" align='center' id="tbllogin" >
	<tbody>
	<tr>
	<td align='center'  >
		<img src='img/logo.jpg' height='90' border='0' />
	</td>
	</tr>
	<tr>
	<td align='center'>
		<span className='logintextlarge'>Customs Apps</span>
		<div className='logintextsmall'>Ministry of Immigration<br/>and Border Services<br/>Turks and Caicos Islands</div>
	</td>
	</tr>
		  <tr>
		  <td align='center' className="inputcellpad" ><input type="text" id="adusername" name='adusername' value={cred.adusername} onChange={(e)=>{handleChange(e)}} placeholder="username" autoComplete='on'  onFocus={handleFocus}  /></td>
		  </tr>
		  <tr>
		  <td align='center' className="inputcellpad" ><input type="password" placeholder="password" id="pwd" name='pwd' onChange={(e)=>{handleChange(e)}} value={cred.pwd}  autoComplete='off'  onFocus={handleFocus}  /></td>
		  </tr>
	{cred.otpsent==true && <>
		  <tr>
		  <td align='center' className="inputcellpad" ><input type="password" placeholder="one-time password" id="otp" name='otp' onChange={(e)=>{handleChange(e)}} value={cred.otp}  autoComplete='off'  onFocus={handleFocus}  /></td>
		  </tr>
		  <tr>
		  <td align='center' className="inputcellpad" >
			<input type="checkbox"  name="cbtrust" id="cbtrust" value="1" onClick={(e)=>{handleChange(e)}} /><label htmlFor="cbtrust" className="hand" >I trust this device</label>
		  </td>
		  </tr>
		  </>
	}
	
		  <tr>
		  <td align='center' className="inputcellpad" >
		  
			{dowait.on && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
			
		  {!dowait.on && <button className="button" id="btnlogin" onClick={ (e) => { clickLogin(e); } } >login</button> }
						
	
		  </td>
		  </tr>
		  <tr>
		  <td align='center' className="inputcellpad" >&nbsp;</td>
		  </tr>
	</tbody>
	</table>


<div align='center' id="snackbar" ></div>

<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button">&times;</span>
        <div  id='modalsmtext' >
		
		{/*
		<div align='left' >
				A trusted device is one that you control access to such as your mobile phone.
		<br/>You will not be required to complete 2-step verification on this device if you choose to trust it.

		<br/>Do not proceed to trust this device if you are using a public or shared device like a computer at a library or internet cafe.
		<p>
			Please give this device a name if you will trust it:
			<br/><input name="devicename" value={cred.devicename} onChange={(e)=>{handleChange(e);}} style={{textAlign:"center"}} autoComplete="off"  placeholder="device name " />
			&nbsp;&nbsp;(length of name must be 5 or more)
		</p>
		</div>
		
<br/>
		<button className="button" onClick={(e)=>{trustthisdevice(e);}} >trust this device</button>
		*/}
		</div>
    </div>
</div>
	
	</>
);

}//end class

{
/*
onClick="document.getElementById('id01').style.display='none'"
onClick="document.getElementById('id01').style.display='none'"
*/
}

export default Login; 

